import { defineStore } from 'pinia';

export const useSkillStore = defineStore('skills', {
    state: () => ({
        skills: [] as any[],
        skill: null as any | null,
    }),
    actions: {
        async fetchSkills() {
            return useNuxtApp().$api().v2.skills.list({
                retry: 3,
                retryDelay: 1500,
            }).then(response => {
                this.skills = response
                return response;
            });
        },
        async fetchSkill(id: string) {
            this.skill = await useNuxtApp().$api().v2.skills.get(id);
        },
    }
})